import { Switch as HeadlessSwitch, SwitchProps } from '@headlessui/react';



export function Switch(props: SwitchProps) {
    return (
        <HeadlessSwitch
            {...props}
            className="group relative inline-flex h-4 w-7 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 data-[checked]:bg-primary"
        >
            <span
                aria-hidden="true"
                className="pointer-events-none inline-block size-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-3"
            />
        </HeadlessSwitch>
    );
}

export default Switch;

